import React from "react";
import {
  TICKET_VARIANT_MODAL,
  ticketPerforationLine,
} from "../utils/ticketPath";

/**
 * Dotted “tear line” between the left and right ticket notches.
 */
const TicketPerforation = ({
  width,
  height,
  className = "",
  variant = TICKET_VARIANT_MODAL,
  notchCenterY,
  stroke = "rgba(255, 255, 255, 0.88)",
  strokeWidth = 1.75,
  strokeDasharray = "2.5 6",
}) => {
  if (width < 8 || height < 8) return null;
  const { x1, y1, x2, y2 } = ticketPerforationLine(
    width,
    height,
    variant,
    notchCenterY
  );

  return (
    <svg
      className={className}
      viewBox={`0 0 ${width} ${height}`}
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      aria-hidden
      focusable="false"
    >
      <line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeDasharray={strokeDasharray}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default TicketPerforation;
